import * as _XPids from './xPidConfigs';
export const getXPidParams = (publicationCode, categories = []) => {
  return _XPids[publicationCode](categories);
};
